import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDownsize2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDownsize2"><Path fillRule="evenodd" clipRule="evenodd" d="M11 11H3V9H9V3H11V11Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 11H13V3H15V9H21V11Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M13 21V13H21V15H15V21H13Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M9 21V15H3V13H11V21H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDownsize2;
